import BatchJobsCollection from '../batchJobs';

export const batchJobs = new BatchJobsCollection([]);

export default batchJobs;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
// TODO: this is still needed as a global due to netx model inception in netx model and batch jobs
// if (process.env.NODE_ENV !== 'production') {
setGlobal({batchJobs});
//}
